import { ActionCreator } from 'app/redux/ActionCreator';
import { ActionTypes, ISendMailAction, ISendMailState } from 'app/redux/SendMail/reducer';
import { SES } from 'aws-sdk';

class SendMailActionCreator extends ActionCreator<ISendMailState, ISendMailAction> {
  sendEmail(name: string, email: string, message: string) {
    return this.dispatchAsync((getState) => {
      return new Promise((resolve, reject) => {
        fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/sendemail', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name,
            message,
            email,
          }),
        })
          .then((result) => {
            const sendmail: ISendMailState = { name, email, message, error: null };
            const action = { type: ActionTypes.SendMail, sendmail };
            resolve(action);
          })
          .catch((error) => {
            const sendmail: ISendMailState = { name, email, message, error };
            const action = { type: ActionTypes.SendMail, sendmail };
            reject(action);
          });
      });
    });
  }
}

const SendMailAction = new SendMailActionCreator();

export { SendMailAction, SendMailActionCreator };



// WEBPACK FOOTER //
// ./src/app/redux/SendMail/actions/index.ts